import { ComponentProps, FC } from "react";
import { View } from "react-native";

import { cn } from "@/utils/tailwind";

import { VnBox } from "./VnBox";

type VnSkeletonPropsType = ComponentProps<typeof View>;

export const VnSkeleton: FC<VnSkeletonPropsType> = ({
  className,
  ...props
}) => {
  return (
    <VnBox
      className={cn("bg-accent animate-pulse rounded-md", className)}
      {...props}
    />
  );
};
